export { default } from "./LightBox";
